// Global Instructions Rule Applied!
// cfg.sbic_investor_types — the SBA capital treatment of an investor entity
// for SBIC Regulatory Capital (13 CFR 107.50 / 107.230). Behaviour flags ride
// along so the UI can explain a category without hardcoding it.
import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const SbicInvestorTypeModelSchema = z
  .object({
    id: z.number(),
    label: z.string(),
    // the whole closed commitment counts (Institutional Investor); false = paid-in only
    unfunded_commitment_counts: z.boolean(),
    // State/local government money: counted up to 33% of Regulatory Capital in aggregate
    subject_to_government_cap: z.boolean(),
    display_order: z.number().nullish()
  })
  .strict()

export const SbicInvestorTypeModelFields = makeFieldKeys(SbicInvestorTypeModelSchema)

export type SbicInvestorTypeModel = z.infer<typeof SbicInvestorTypeModelSchema>

export function validateSbicInvestorTypeModel(data: unknown): SbicInvestorTypeModel {
  try {
    return validateWithZodSchema(SbicInvestorTypeModelSchema, data, 'sbic investor type model')
  } catch (error) {
    throw new Error(`SBIC investor type model validation failed: ${error}`)
  }
}
